import React, { useState } from "react";
import { Link, navigate } from "gatsby";

import {
    surveyHeader,
    surveyLogo,
    brand,
    navLinks,
    loginButton,
    menuToggle,
    mobileMenu,
    mobileMenuOpen,
    alerts,
} from "./headerSurvey.module.scss";

import logoFull from "../../../assets/images/logo_full.png";
import AlertList from "../alert-list";
import useUser from "../../../apps/auth/hooks/use-user";
import { getAbsolutePath } from "../../../apps/utility/routes.utility";

interface IHeaderSurveyProps {
    className?: string;
}

const navItems = [
    { label: "O Mnie", to: "/o-nas/" },
    { label: "Blog", to: "/blog/" },
    { label: "Kontakt", to: "/kontakt/" },
];

const HeaderSurvey: React.FC<IHeaderSurveyProps> = ({ className }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { isLoggedIn } = useUser();
    const accountLinkHref = isLoggedIn ? getAbsolutePath("ACCOUNT_DASHBOARD") : "/auth/";
    const accountLinkLabel = isLoggedIn ? "Twoje konto" : "Zaloguj się";

    return (
        <header className={className}>
            <nav className={surveyHeader} aria-label="Główna nawigacja">
                <Link to="/" className={brand}>
                    <img
                        src={logoFull}
                        alt="Fashion Fairy Virtual Stylist"
                        className={surveyLogo}
                    />
                </Link>
                <div className={navLinks}>
                    {navItems.map(item => (
                        <Link key={item.to} to={item.to}>
                            {item.label}
                        </Link>
                    ))}
                </div>
                <Link to={accountLinkHref} className={loginButton}>
                    {accountLinkLabel}
                </Link>
                <button
                    className={menuToggle}
                    type="button"
                    aria-label={isMenuOpen ? "Zamknij menu" : "Otwórz menu"}
                    aria-expanded={isMenuOpen}
                    aria-controls="generator-mobile-menu"
                    onClick={() => setIsMenuOpen(isOpen => !isOpen)}
                >
                    <span />
                    <span />
                    <span />
                </button>
                <div
                    id="generator-mobile-menu"
                    className={[mobileMenu, isMenuOpen ? mobileMenuOpen : ""].join(" ")}
                >
                    {navItems.map(item => (
                        <Link key={item.to} to={item.to}>
                            {item.label}
                        </Link>
                    ))}
                    <button
                        type="button"
                        onClick={() => {
                            setIsMenuOpen(false);
                            navigate(accountLinkHref);
                        }}
                    >
                        {accountLinkLabel}
                    </button>
                </div>
                <AlertList className={alerts} />
            </nav>
        </header>
    );
};

export default HeaderSurvey;
